import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { LayoutService } from '../../service/layout.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  animations: [
    trigger('toastAnimation', [
      state(
        'false',
        style({
          opacity: 0,
          transform: 'translate3D(0, 0, 0)',
        }),
      ),
      state(
        'true',
        style({
          opacity: 1,
          transform: 'translate3D(0, var(--anim), 0)',
        }),
      ),
      transition('* => false', [
        style({
          opacity: 1,
          transform: 'translate3D(0, var(--anim), 0)',
        }),
        animate(
          250,
          style({
            opacity: 0,
            transform: 'translate3D(0, 0, 0)',
          }),
        ),
      ]),
    ]),
  ],
})
export class ToastComponent {
  id!: string;
  height: number = 0;
  offset: number = 0;
  type?: 'success' | 'fail';
  customClass: string = '';
  duration: number = 5000;
  zIndex: number = 1100;
  title?: string;
  message: string = '';
  showBox?: boolean;
  showClose: boolean = false;
  /**鼠标悬停暂停计时器 ：默认使用该功能，需要关闭时通过外部传参false */
  enableHoverToStop: boolean = true;

  isH5 = toSignal(this.layout.isH5$);

  onClose = () => {};
  onDestroy = () => {};
  onClick?: () => void;

  constructor(
    private changeRef: ChangeDetectorRef,
    private layout: LayoutService,
  ) {}

  strokeDashoffset = -126;

  reverse = '';
  timer?: unknown;

  viewInit(el: HTMLElement) {
    this.height = el.offsetHeight;
    this.show();
    this.startCountdown();
  }

  startCountdown() {
    if (this.duration > 0) {
      const speed = (10 / this.duration) * this.strokeDashoffset;
      this.timer = setInterval(() => {
        this.duration -= 10;
        this.strokeDashoffset - speed < 0
          ? (this.strokeDashoffset = this.strokeDashoffset - speed)
          : (this.strokeDashoffset = 0);
        if (this.duration <= 0) {
          clearInterval(this.timer as number);
          this.close();
        }
      }, 10);
    }
  }

  show(): void {
    this.showBox = true;
    this.changeRef.detectChanges();
  }

  close(): void {
    this.showBox = false;
    this.onClose();
    this.onDestroy();
  }

  onMouseEnter() {
    if (!this.enableHoverToStop) {
      return;
    }
    // 鼠标移入时停止倒计时
    clearInterval(this.timer as number);
  }

  onMouseLeave() {
    if (!this.enableHoverToStop) {
      return;
    }
    // 鼠标移出时继续倒计时
    this.startCountdown();
  }

  onToastClick() {
    if (typeof this.onClick !== 'function') return;
    this.onClick();
    this.close();
  }
}
